<router-outlet></router-outlet>
<!-- Alerts placeholder -->
<et-notifications-list></et-notifications-list>
